module.exports = __webpack_public_path__ + "img/霾.9a73b9a5.png";